import React, { FunctionComponent } from 'react'
import { Heading, Text } from '@afterpaytouch/core'
import { Money } from '../../../../component'
import type { Money as MoneyValue } from '@afterpay/types'
import { Trans } from '../../../../utils/convergence'
import styles from './styles.module.css'
import clsx from 'clsx'

interface ItemHeaderProps {
  id: string
  index: number
  name: string
  price?: MoneyValue | null
  secondaryPrice?: MoneyValue | null
  strikeThroughPrice?: MoneyValue
  showAsterisk?: boolean
  isPayInFull?: boolean
}

export const ItemHeader: FunctionComponent<ItemHeaderProps> = ({ id, index, name, price, secondaryPrice, strikeThroughPrice, showAsterisk, isPayInFull }) => {
  return (
    <div className={clsx(styles.itemHeader, !isPayInFull && styles.itemHeaderCaret)}>
      <div className={styles.nameContainer}>
        <Heading size='M' renderAs='span' testNameSpace={`item-${index}-name`} color='Black'>
          {name}
        </Heading>
        {secondaryPrice && (
          <Text>
            <Trans
              i18nKey='summary:appleRetail.tradeInValue'
              components={{
                money: <Money value={secondaryPrice} testNameSpace={`item-${index}-trade-in-value`} />,
              }}
            />
          </Text>
        )}
      </div>
      <div className={!isPayInFull ? styles.priceContainer : undefined}>
        <div>
          <Money color={showAsterisk ? 'Success' : undefined} size='M' bold value={price ?? undefined} testNameSpace={`item-${index}-price`} />
          {showAsterisk && <sup className={styles.asterisk}>*</sup>}
        </div>
        {strikeThroughPrice !== undefined && (
          <div>
            <Money color='Subtle' value={strikeThroughPrice} strikethrough />
          </div>
        )}
      </div>
    </div>
  )
}
